import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import CatalogItemsConstants from '../constants/catalog_items_constants';
import ProductModel from './models/product';

class CatalogItemsStoreClass extends ReduceStore {
    getInitialState() {
        return {
            loadingProducts: false,
            products: [],
            buyerAssistUrl: null
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.CATALOG_ITEMS_ACTION) {
            switch (action.type) {
                case CatalogItemsConstants.SET_PRODUCTS_ACTION:
                    state.loadingProducts = false;
                    state.products = action.payload.map((product) => {
                        return new ProductModel(product);
                    });

                    this.__emitChange();
                    break;
                case CatalogItemsConstants.LOAD_CATALOG_ITEMS_ACTION:
                    state.loadingProducts = true;
                    this.__emitChange();
                    break;
                case CatalogItemsConstants.SET_BUYER_ASSIST_URL:
                    state.buyerAssistUrl = action.payload;
                    this.__emitChange();
                    break;
            }
        }

        return state;
    }
}

const CatalogItemsStore = new CatalogItemsStoreClass(Dispatcher);
export default CatalogItemsStore;